<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="x-SECTION-BREAK"> </p>
<p class="x2FM-RM-TTL" id="toc_marker-1">Contents</p>
<div id="toc_marker-2"><p class="x2TOC"><a href="#/Chapter1#toc_marker-2">The Daughter of Belgium, by Marci Jefferson</a></p></div>
<div id="toc_marker-3"><p class="x2TOC"><span href="#/Chapter2#toc_marker-3" title="Link target outside of Sample">The Record Set Right, by Lauren Willig</span></p></div>
<div id="toc_marker-4"><p class="x2TOC"><span href="#/Chapter3#toc_marker-4" title="Link target outside of Sample">All for the Love of You, by Jennifer Robson</span></p></div>
<div id="toc_marker-5"><p class="x2TOC"><span href="#/Chapter4#toc_marker-5" title="Link target outside of Sample">After You’ve Gone, by Evangeline Holland</span></p></div>
<div id="toc_marker-6"><p class="x2TOC"><span href="#/Chapter5#toc_marker-6" title="Link target outside of Sample">Something Worth Landing For, by Jessica Brockmole</span></p></div>
<div id="toc_marker-7"><p class="x2TOC"><span href="#/Chapter6#toc_marker-7" title="Link target outside of Sample">Hour of the Bells, by Heather Webb</span></p></div>
<div id="toc_marker-8"><p class="x2TOC"><span href="#/Chapter7#toc_marker-8" title="Link target outside of Sample">An American Airman in Paris, by Beatriz Williams</span></p></div>
<div id="toc_marker-9"><p class="x2TOC"><span href="#/Chapter8#toc_marker-9" title="Link target outside of Sample">The Photograph, by Kate Kerrigan</span></p></div>
<div id="toc_marker-10"><p class="x2TOC"><span href="#/Chapter9#toc_marker-10" title="Link target outside of Sample">Hush, by Hazel Gaynor</span></p></div>
<div id="toc_marker-11"><p class="x2TOC-AFTER-TXB1"><span class="Italic"><span href="#/AbouttheAuthor#toc_marker-11" title="Link target outside of Sample">About the Authors</span></span></p></div>
<div id="toc_marker-12"><p class="x2TOC"><span class="Italic"><span href="#/Credits#toc_marker-12" title="Link target outside of Sample">Credits</span></span></p></div>
<div id="toc_marker-13"><p class="x2TOC"><span class="Italic"><span href="#/Copyright#toc_marker-13" title="Link target outside of Sample">Copyright</span></span></p></div>
<div id="toc_marker-14"><p class="x2TOC"><span class="Italic"><span href="#/AboutthePublisher#toc_marker-14" title="Link target outside of Sample">About the Publisher</span></span></p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?48a28262